import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AgentDto, TicketAdditionalFileDto, TicketDto, TicketElementDto, TicketStepDto, FileUploadDto } from '../../../../../service/dto';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { finalize, of, Subscription } from 'rxjs';
import { HttpFileService } from '../../../../../service/http-file.service';
import { HttpEventType } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzSelectOptionInterface } from 'ng-zorro-antd/select';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormControlWrapper } from '../../../../../components/dynamic-form/dynamic-form-abstract';

export class UploadFile {
	id!: number;
	name!: string;
	isAdditional!: boolean;
	formControl!: FormControl;
	formControlWrapper!: FormControlWrapper;

	get isNew(): boolean{
		return this.isAdditional == true && this.formControl!.hasValidator?.(Validators.required) === false;
	}
	// get canBeDeleted(): boolean{
	// 	return this.isAdditional == true && this.formControl!.hasValidator?.(Validators.required) === false;
	// }
	get hasFile(): boolean {
		return this.formControl.value != null;
	}
}

@Component({
	selector: 'app-ticket-form-section-images',
	standalone: false,
	templateUrl: './ticket-form-section-images.component.html',
	styleUrl: './ticket-form-section-images.component.scss'
})
export class TicketFormSectionImagesComponent implements OnInit {
	@Input() ticket!: TicketDto;
	@Input() step!: TicketStepDto;
	@Input() formControls!: FormControlWrapper[];
	@Input() additionalFileFormGroup!: FormGroup;
	@ViewChild('fileNameModal', { static: true }) fileNameModal!: TemplateRef<any>;
	@ViewChild('additionalFilesModal', { static: true }) additionalFilesModalTpl!: TemplateRef<any>;
	@ViewChild('newFileNameModal', { static: true }) newFileNameModalTpl!: TemplateRef<any>;
	show!: boolean
	@Input() readonly!: boolean;


	uploadProgress?: number;
	fileNameForm!: FormGroup;
	fileNameOptions: NzSelectOptionInterface[] = [];

	constructor(
		private fileService: HttpFileService,
		private fb: FormBuilder,
		private modal: NzModalService) {
	}

	ngOnInit(): void {
		this.show = true;
		// this.readonly = this.step.isCurrentState == false;
		this.fileNameForm = this.fb.group({
			fileName: [[], Validators.required]
		});
	}
	customUpload = (item: NzUploadXHRArgs): any => {
		this.fileNameOptions = this.step.sections
			.flat()
			.map(item => item.elements)
			.flat()
			.filter(item => item.dataType == 'File')
			.map(item => {
				return { label: item.label, value: item };
			});
		this.step.additionalFiles
			.filter(item => item.label.trim().length > 0)
			.map(item => {
				return { label: item.label, value: item };
			})
			.forEach(item => this.fileNameOptions.push(item));

		const modalRef = this.modal.create({
			nzTitle: 'Choose File Names',
			nzContent: this.fileNameModal,
			nzFooter: [
				{
					label: 'Cancel',
					onClick: () => modalRef.destroy()
				},
				{
					label: 'OK',
					type: 'primary',
					onClick: () => {
						if (this.fileNameForm.valid) {
							const values = this.fileNameForm.value.fileName;

							modalRef.destroy(values);
						}
					}
				}
			]
		});
		modalRef.afterClose.subscribe((result: TicketElementDto | TicketAdditionalFileDto | undefined) => {
			if (!result) {
				return;
			}
			this.uploadProgress = 0;
			// let name = (Object.hasOwn(result as object, 'isReplaced')) ? ((result as TicketElementDto).label) : (result as UploadFile).name;

			const subscription = this.fileService.uploadWithProgress(result.label, item.file as any)
				.pipe(finalize(() => this.uploadProgress = undefined))
				.subscribe({
					next: (event) => {
						if (event.type === HttpEventType.Response) {
							const body = event.body as FileUploadDto;
							this.uploadProgress = 100;

							if ((Object.hasOwn(result as object, 'isReplaced'))) {
								const additionalField = result as TicketAdditionalFileDto;
								this.additionalFileFormGroup.get(additionalField.label)?.setValue(body.uuid);
							} else {
								const ticketElement = result as TicketElementDto;
								this.formControls.filter(item => item.element.id == ticketElement.id)[0].control.setValue(body.uuid);
							}
						}
						if (event.type === HttpEventType.UploadProgress) {
							console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
							const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
							this.uploadProgress = percentage == 100 ? 99 : percentage;
						}
					},
					error: (err) => item.onError!(err, item.file!)
				});
			return { abort() { subscription.unsubscribe(); } };
		});
	}

	get files(): UploadFile[] {
		const out = this.formControls
			.filter(item => item.element.dataType == 'File')
			.sort((i1, i2) => i1.element.name.localeCompare(i2.element.name))
			.map(item => {
				const uploadFile = new UploadFile();
				uploadFile.name = item.element.name;
				uploadFile.formControl = item.control;
				uploadFile.formControlWrapper = item;
				uploadFile.isAdditional=false;
				return uploadFile;
			});
		Object.keys(this.additionalFileFormGroup.controls)
			.sort((i1, i2) => i1.localeCompare(i2))
			.forEach(key => {
				const uploadFile = new UploadFile();
				uploadFile.name = key;
				uploadFile.isAdditional=true;
				uploadFile.formControl = this.additionalFileFormGroup.get(key)! as FormControl;
				out.push(uploadFile);
			});
		return out;
	}

	addAdditionalFiles() {
		const modalRef = this.modal.create({
			nzTitle: 'Enter File Name',
			nzContent: this.newFileNameModalTpl,
			nzFooter: [
				{
					label: 'Cancel',
					onClick: () => modalRef.destroy()
				},
				{
					label: 'OK',
					type: 'primary',
					onClick: () => {
						const fileName = this.fileNameForm.value.fileName;
						if (fileName && fileName.trim().length > 0) {
							modalRef.destroy(fileName.trim());
						}
					}
				}
			]
		});
		modalRef.afterClose.subscribe((fileName: string | undefined) => {
			if (!fileName) {
				return;
			}
			if(this.additionalFileFormGroup.contains(fileName)){
				return;
			}

			const item = new TicketAdditionalFileDto();
			item.id = Date.now() * -1;
			item.label = fileName;
			item.uuid = undefined;
			item.isReplaced = false;
			this.step.additionalFiles.push(item);

			const formControl = new FormControl();
			this.additionalFileFormGroup.addControl(fileName, formControl);
		});
	}
	removeAdditionalFile(input: UploadFile) {


		const index = this.step.additionalFiles.indexOf(this.step.additionalFiles.filter(item => item.label == input.name)[0]);
		if (this.step.additionalFiles[index].id > 0) {
			return;
		}
		this.additionalFileFormGroup.removeControl(this.step.additionalFiles[index].label);
		this.step.additionalFiles.splice(index, 1);
	}
}
